// extracted by mini-css-extract-plugin
module.exports = {"mobileTitle":"ListeProduits_mobileTitle__hovVG","photo":"ListeProduits_photo__2day8","nom":"ListeProduits_nom__bJZ4Q"};